module.exports = __webpack_public_path__ + "assets/images/pages/listarobinson/feature-2-icon-2.png?3840d92d";